import { ChevronRight } from "lucide-react";

export const SettingsCard = ({
  icon: Icon,
  label,
  onClick,
  rightElement,
}: {
  icon: React.ElementType;
  label: string;
  onClick?: () => void;
  rightElement?: React.ReactNode;
}) => (
  <div
    className="group max-w-lg w-full bg-white rounded-xl shadow-sm p-6 mt-4 hover:bg-gradient-to-r hover:from-[#5050EA] hover:to-[#85A2FF]"
    onClick={onClick}
  >
    <div className="flex items-center justify-between bg-white rounded-lg p-4 cursor-pointer group-hover:bg-gradient-to-r hover:from-[#5050EA] hover:to-[#85A2FF]">
      <div className="flex items-center space-x-4">
        <Icon className="text-[#6A6A6A] group-hover:text-white" />
        <span className="text-[#6A6A6A] group-hover:text-white">{label}</span>
      </div>
      {rightElement || (
        <ChevronRight className="text-gray-400 group-hover:text-white" />
      )}
    </div>
  </div>
);
